/*  eslint no-underscore-dangle: ["error", { "allow": ["_id"] }]*/

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Table, Input, Button, Pagination, DatePicker } from 'antd'
import queryString from 'query-string'
import { history } from '../../../store'

import './index.css'

const propTypes = {
  manipulationList: PropTypes.array.isRequired,
  getManipulationList: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  manipulationCount: PropTypes.number.isRequired,
}
const defaultProps = {
  manipulationList: [],
  isFetching: false,
  manipulationCount: 0,
}

const columns = [
  {
    title: 'Client',
    dataIndex: 'clientFullName',
    render: (name, record) => <Link to={`/clients/${record.clientId}`}>{name}</Link>,
  },
  {
    title: 'Date',
    dataIndex: 'date',
    sorter: true,
    render: date => moment(date).format('DD/MM/YY'),
  },
  {
    title: 'Manipulation',
    dataIndex: 'manipulationName',
    render: (manipulation, record) => <Link to={`/manipulations/${record._id}`}>{manipulation}</Link>,
  },
  {
    title: 'Cost',
    dataIndex: 'cost',
  },
  {
    title: 'Desctiption',
    dataIndex: 'description',
  },
]

export class Manipulations extends Component {
  constructor() {
    super()
    this.state = {}
    this.clearSearch = this.clearSearch.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onShowSizeChange = this.onShowSizeChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.onDateFilterChange = this.onDateFilterChange.bind(this)
  }

  componentDidMount() {
    const { getManipulationList } = this.props
    getManipulationList()
  }

  handleTableChange = (pagination, filters, sorter) => {
    // console.log(pagination, filters, sorter)
    const { location, getManipulationList } = this.props
    const parsed = queryString.parse(location.search)
    if (sorter.field) {
      parsed.orderBy = sorter.field
      parsed.order = sorter.order
    } else {
      delete parsed.orderBy
      delete parsed.order
    }
    history.push({
      pathname: '/manipulations',
      search: queryString.stringify(parsed)
    })
    getManipulationList()
  }

  clearSearch() {
    const { location, getManipulationList } = this.props
    this.searchField.input.input.value = ''
    const parsed = queryString.parse(location.search)
    delete parsed.search
    delete parsed.clientId
    history.push({
      pathname: '/manipulations',
      search: queryString.stringify(parsed)
    })
    getManipulationList()
  }

  onShowSizeChange(current, pageSize) {
    const { location, getManipulationList } = this.props
    const parsed = queryString.parse(location.search)
    parsed.perPage = pageSize
    parsed.page = current
    history.push({
      pathname: '/manipulations',
      search: queryString.stringify(parsed)
    })
    getManipulationList()
  }

  onPageChange(pageNumber) {
    const { location, getManipulationList } = this.props
    const parsed = queryString.parse(location.search)
    parsed.page = pageNumber
    history.push({
      pathname: '/manipulations',
      search: queryString.stringify(parsed)
    })
    getManipulationList()
  }

  onSearchChange(val) {
    const { location, getManipulationList } = this.props
    const parsed = queryString.parse(location.search)
    val ? parsed.search = val : delete parsed.search
    history.push({
      pathname: '/manipulations',
      search: queryString.stringify(parsed)
    })
    getManipulationList()
  }

  onDateFilterChange(val) {
    const { location, getManipulationList } = this.props
    const parsed = queryString.parse(location.search)
    if (val.length) {
      parsed.from = val[0].format('YYYY-MM-DD')
      parsed.to = val[1].format('YYYY-MM-DD')
    } else {
      delete parsed.from
      delete parsed.to
    }
    history.push({
      pathname: '/manipulations',
      search: queryString.stringify(parsed)
    })
    getManipulationList()
  }

  render() {
    const { manipulationList, isFetching, manipulationCount, location } = this.props
    const { search, from, to, perPage, page } = queryString.parse(location.search)
    return (
      <div className='manipulations'>
        <div className='first-row'>
          <DatePicker.RangePicker
            size={'large'}
            onChange={this.onDateFilterChange}
            defaultValue={from && to ? [moment(from), moment(to)] : []}
          />
          <div className='search-wrapper'>
            <Input.Search
              ref={node => (this.searchField = node)}
              placeholder='Type to search by client'
              defaultValue={search || ''}
              size={'large'}
              onSearch={this.onSearchChange}
            />
            <Button
              size='large'
              icon='reload'
              onClick={this.clearSearch}
            />
          </div>
        </div>
        <Table
          columns={columns}
          rowKey={record => record._id}
          dataSource={manipulationList}
          pagination={false}
          loading={isFetching}
          onChange={this.handleTableChange}
        />
        <div className='second-row'>
          <Pagination
            showSizeChanger
            pageSize={Number(perPage) || 30}
            pageSizeOptions={['10', '30', '50', '100']}
            onShowSizeChange={this.onShowSizeChange}
            onChange={this.onPageChange}
            defaultCurrent={Number(page) || 1}
            total={manipulationCount}
          />
        </div>
      </div>
    )
  }
}


Manipulations.propTypes = propTypes
Manipulations.defaultProps = defaultProps
export default Manipulations



// WEBPACK FOOTER //
// ./src/containers/manipulations/list/Manipulations.js